import type { CabRepeatValue } from '../types/cabSchedule';

export const CAB_REPEAT_OPTIONS: Array<{ value: CabRepeatValue; label: string }> = [
  { value: '', label: 'Does not repeat' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekdays', label: 'Every Weekday (Mon–Fri)' },
  { value: 'weekends', label: 'Every Weekend (Sat, Sun)' },
  { value: 'weekMWF', label: 'Every Mon, Wed, Fri' },
  { value: 'weekTT', label: 'Every Tue, Thu' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
  { value: 'specific', label: 'Specific' },
];

/** JS getDay() values for Specific "Repeat on" checkboxes (Mon→Sun). */
export const CAB_WEEKDAY_OPTIONS: Array<{ value: number; label: string }> = [
  { value: 1, label: 'Mon' },
  { value: 2, label: 'Tue' },
  { value: 3, label: 'Wed' },
  { value: 4, label: 'Thu' },
  { value: 5, label: 'Fri' },
  { value: 6, label: 'Sat' },
  { value: 0, label: 'Sun' },
];

export function getRepeatLabel(value: CabRepeatValue): string {
  if (value === 'specific') return 'Repeats on specified days';
  const match = CAB_REPEAT_OPTIONS.find((o) => o.value === value);
  return match?.label ?? (value ? String(value) : 'Does not repeat');
}
